import { Button, Spin, Avatar, Tooltip, Popconfirm } from "antd";
import { useState } from "react";
import { DeleteFilled } from "@ant-design/icons";
import { useUserContext } from "../../contexts/UserContext";
import Toast from "../../helpers/Toast";
import { catchError } from "../../services/DaoService";
import { MembreTacheService } from "../../services/MembreTacheService";
import PropTypes from "prop-types";
import styles from "./MembreTacheList.module.scss";

const MembreTacheList = ({
  paginationData,
  setPaginationData,
  membreTaches,
  setMembreTaches,
  searchParams,
  isReadOnly = false,
  canManage = false,
}) => {
  const { check } = useUserContext();
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);

  const loadMore = () => {
    if (paginationData?.next_page_url) {
      setLoadingMore(true);
      MembreTacheService.post(paginationData.next_page_url, searchParams)
        .then((response) => {
          if (!response) return;
          setPaginationData(response.data);
          setMembreTaches((prev) => [...prev, ...response.data.data]);
        })
        .catch(catchError)
        .finally(() => setLoadingMore(false));
    }
  };

  const handleDelete = (uid) => {
    setLoading(true);
    MembreTacheService.getInstance()
      .remove(uid)
      .then((response) => {
        Toast.success(response.message);
        setMembreTaches((items) => items.filter((item) => item.uid !== uid));
      })
      .catch(catchError)
      .finally(() => setLoading(false));
  };

  const canDelete = canManage && !isReadOnly;

  return (
    <Spin spinning={loading}>
      <div className={styles.list}>
        {membreTaches.map((membre) => {
          const user = membre.user;
          return (
            <div key={membre.id} className={styles.row}>
              <div className={styles.rowAvatar}>
                <Avatar size={32} src={user?.avatar}>{user?.name?.[0]}</Avatar>
              </div>
              <div className={styles.rowInfo}>
                <div className={styles.rowName}>{user?.name}</div>
                <div className={styles.rowSub}>
                  <span className={styles.rowEmail}>{user?.email}</span>
                  {user?.personnel?.departement?.nom && (
                    <span className={styles.rowDept}>{user.personnel.departement.nom}</span>
                  )}
                </div>
              </div>
              {canDelete && (
                <div className={styles.rowActions}>
                  <Popconfirm
                    title="Retirer cet observateur ?"
                    okText="Retirer"
                    cancelText="Annuler"
                    okType="danger"
                    onConfirm={() => handleDelete(membre.uid)}
                  >
                    <Tooltip title="Retirer">
                      <Button
                        type="text"
                        size="small"
                        danger
                        icon={<DeleteFilled />}
                      />
                    </Tooltip>
                  </Popconfirm>
                </div>
              )}
            </div>
          );
        })}
      </div>
      {paginationData?.next_page_url && (
        <div className={styles.loadMore}>
          <Button size="small" onClick={loadMore} loading={loadingMore}>
            Charger plus
          </Button>
        </div>
      )}
    </Spin>
  );
};

export default MembreTacheList;

MembreTacheList.propTypes = {
  paginationData: PropTypes.object.isRequired,
  searchParams: PropTypes.object,
  setPaginationData: PropTypes.func.isRequired,
  membreTaches: PropTypes.array.isRequired,
  setMembreTaches: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool,
  canManage: PropTypes.bool,
};
